/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon20Light = forwardRef('ArrowUiCornerOutUpRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.5 3A2.5 2.5 0 0 0 3 5.5v8A2.5 2.5 0 0 0 5.5 16h8a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 1 1 0v1a3.5 3.5 0 0 1-3.5 3.5h-8A3.5 3.5 0 0 1 2 13.5v-8A3.5 3.5 0 0 1 5.5 2h1a.5.5 0 0 1 0 1h-1Z" }),
        React.createElement("path", { d: "M16 3.707 9.854 9.854a.5.5 0 0 1-.708-.708L15.293 3H10.5a.5.5 0 0 1 0-1h5A1.5 1.5 0 0 1 17 3.5v5a.5.5 0 0 1-1 0V3.707Z" })));
});
